import React, { createContext, useContext, useState } from 'react';

// Create the user authentication context
const AuthContext = createContext();

// Create a custom hook for using the AuthContext
export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const login = (userData) => {
    // Perform user login logic, set the user state, and possibly store authentication data.
    setUser(userData);
  };

  const logout = () => {
    // Perform user logout logic, clear the user state, and possibly clear authentication data.
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
